export enum PhoneVerificationFlowStatusType {
    UNINITIALIZED = "uninitialized",
    INITIALIZED = "initialized",
    SUCCESS = "success"
}
export enum PhoneVerificationFlowStatusType {
    UNINITIALIZED = "uninitialized",
    INITIALIZED = "initialized",
    SUCCESS = "success"
}
